export enum BatchInitiationMethod {
  MANUALLY = 'manually',
  AUTO = 'auto',
}
